import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as cursadasService from '../../services/cursadas/cursadasService';
import {
  classifyCursadasError,
  toCreateCursadaPayload,
  validateCursadaForm,
  validateDictadoMatch
} from '../../services/cursadas/cursadasDto';
import { LookupPeriodoCursada } from '../PeriodoCursada/LookupPeriodoCursada';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';

export class AddCursada extends Component {
  static displayName = AddCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      code: "",
      name: "",
      anioDictado: "",
      dictado: "",
      showErrorMessage: false,
      success: false,
      errorMessage: "",
      tagDataMateria: [{ id: "", text: "" }],
      tagDataPeriodoCursada: [{ id: "", text: "" }],
      alumno: { alumnoDni: "", alumnoCodigo: 0, alumnoNombre: "" },
      materia: { materiaCarreraCodigo: "", descripcion: "" },
      cursada: { cursadacod: "", cursadadescripcion: "" },
      showLookupMaterias: false,
      showLookupPeriodoCursada: false,
      practica: "",
      value: { value: '', label: '' },
      valueDictado: { value: '', label: '' },
      name: ""
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeletePeriodoCursada = this.handleDeletePeriodoCursada.bind(this);
    this.handleSelectCarreraItem = this.handleSelectCarreraItem.bind(this);
    this.handleShowCarreraLookup = this.handleShowCarreraLookup.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDictadoChangeInput = this.handleDictadoChangeInput.bind(this);
    this.handleAnioChangeInput = this.handleAnioChangeInput.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
    this.handleSelectPeriodoCursadaItem = this.handleSelectPeriodoCursadaItem.bind(this);
    this.handleShowPeriodoCursadaLookup = this.handleShowPeriodoCursadaLookup.bind(this);
    this.handleHidePeriodoCursadaLookup = this.handleHidePeriodoCursadaLookup.bind(this);
  }

  handleConfirmButton = () => {
    const dictadoCorrecto = validateDictadoMatch(this.state.dictado, this.state.anioDictado);
    const okToSave = validateCursadaForm({
      materiaPresent: this.state.materia.descripcion.length > 0,
      periodoPresent: this.state.cursada.cursadadescripcion.length > 0
    });

    if (okToSave && dictadoCorrecto) {
      this.saveStudent();
    } else {
      var errorMessage = "";
      if (!okToSave) {
        errorMessage = "Todos los campos son obligatorios";
      } else {
        errorMessage = "La materia seleccionada no se dicta en el período seleccionado";
      }
      this.setState({ showErrorMessage: true, errorMessage: errorMessage });
    }
  }

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    const dictado = carreraProperties[4]
    this.setState({
      showLookupMaterias: false,
      dictado: dictado,
      materia: {
        materiaCarreraCodigo: carreraProperties[0],
        descripcion: carreraProperties[1] + " - " + carreraProperties[2] + " - " + carreraProperties[3]
      }
    });
  }

  handleSelectPeriodoCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    const periodo = carreraProperties[3]
    this.setState({
      showLookupPeriodoCursada: false,
      anioDictado: periodo,
      cursada: {
        cursadacod: carreraProperties[0],
        cursadadescripcion: carreraProperties[1] + " - " + carreraProperties[2]
      }
    });
  }

  async componentDidMount() {
    await constantClass.canAccess('WWCursada');
  }

  handleSelect = e => {
    this.setState({ practica: e.value, value: e });
  }

  handleHideLookup = () => {
    this.setState({ showLookupCarreras: false });
  }

  handleHidePeriodoCursadaLookup = () => {
    this.setState({ showLookupPeriodoCursada: false });
  }

  handleShowCarreraLookup = () => {
    this.setState({ showLookupMaterias: true });
  }

  handleShowPeriodoCursadaLookup = () => {
    this.setState({ showLookupPeriodoCursada: true });
  }

  handleNameChangeInput = e => {
    this.setState({ name: e.target.value });
  }

  handleAnioChangeInput = e => {
    this.setState({ anioDictado: e.target.value });
  }

  handleDictadoChangeInput = e => {
    this.setState({ dictado: e.value, valueDictado: e });
  }

  handleCodeChange = e => {
    this.setState({ code: e.target.value });
  }

  handleDelete = (i) => {
    this.setState({ tagDataMateria: this.state.tagDataMateria.filter(tag => tag.id !== i) });
  }

  handleDeletePeriodoCursada = (i) => {
    this.setState({ tagDataPeriodoCursada: this.state.tagDataPeriodoCursada.filter(tag => tag.id !== i) });
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-cur" />;
    }

    const { loading } = this.state;
    const materiaDisplay = this.state.materia.descripcion.trim();
    const periodoDisplay = this.state.cursada.cursadadescripcion.trim();

    return (
      <div className="md-page md-add-cursada">
        <Link className="md-page__back-link" to="/md-cur">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nueva Cursada</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione la materia y el período de cursada para registrar una nueva cursada.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Materia</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                  Seleccionar materia
                </button>
              ) : null}
              <div className="md-page__field-readonly">{materiaDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Período de cursada</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowPeriodoCursadaLookup}>
                  Seleccionar período de cursada
                </button>
              ) : null}
              <div className="md-page__field-readonly">{periodoDisplay}</div>
            </div>
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>

        {this.state.showLookupMaterias ? (
          <LookupMaterias selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showLookupPeriodoCursada ? (
          <LookupPeriodoCursada selectItem={this.handleSelectPeriodoCursadaItem} hideLookup={this.handleHidePeriodoCursadaLookup} />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await cursadasService.saveCursada(
        toCreateCursadaPayload({
          materiaCarreraCod: this.state.materia.materiaCarreraCodigo,
          periodoCursadaCod: this.state.cursada.cursadacod
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyCursadasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage });
    }
  }
}
